import { render, staticRenderFns } from "./ContributionCollection.vue?vue&type=template&id=d2dea5d4"
import script from "./ContributionCollection.vue?vue&type=script&lang=js"
export * from "./ContributionCollection.vue?vue&type=script&lang=js"
import style0 from "./ContributionCollection.vue?vue&type=style&index=0&id=d2dea5d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports